import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/employment-status');
}
//Get all active
export function allActive(){
    return http().get('/employment-status/active');
}
//Get Single
export function single(id){
    return http().get(`/employment-status/${id}`);
}
//Add one
export function add(data){
    return http().post('/employment-status', data)
}
//Update
export function update(id, data){
    return http().put(`/employment-status/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/employment-status/${id}`);
}